<script setup>
import {computed, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const store = useStore()
const router = useRouter()

const props = defineProps(['subject', 'isNew'])

const seminar = ref(store.getters['Seminars/seminar'])
const loading = ref(false)
const errorMessage = ref(null)
const isNew = ref(props.isNew)

const formattedDate = computed(()=> {
  if(seminar.value.date){
    const date = new Date(seminar.value.date)
    return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()} ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
  } else {
    return ''
  }
})

async function saveSeminar(){
  loading.value = true
  try {
    seminar.value.subjectId = props.subject.id
    seminar.value.date = new Date().toISOString().slice(0, 19);
    seminar.value = await store.dispatch('Seminars/saveSeminar',{seminarRequest: seminar.value})
    refresh(seminar.value.id, seminar.value.subjectId)
    errorMessage.value = null
  } catch (e) {
    console.log('error ',e)
    errorMessage.value = t('entities.error')
  } finally {
    loading.value = false
  }
}

function refresh(seminarId, subjectId){
  router.replace({
    name: 'SeminarDetail',
    params: {seminarId: seminarId, subjectId: subjectId}
  })
}

</script>

<template>
  <v-row>
    <v-col>
      <v-text-field v-model.trim="seminar.title" :disabled="!isNew" :label="$t('gamification.seminar_name')" variant="underlined" />
    </v-col>
    <v-col>
      <v-text-field :model-value="subject?.name" :disabled="true" :label="$t('gamification.subject')" variant="underlined" />
    </v-col>
  </v-row>
  <v-row v-if="!isNew">
    <v-col>
      <v-text-field :model-value="subject?.owner.login" :disabled="true" prepend-icon="person" :label="$t('gamification.created_by')" variant="plain" />
    </v-col>
    <v-col>
      <v-text-field :model-value="formattedDate" :disabled="true"  prepend-icon="event" :label="$t('gamification.created')" variant="plain" />
    </v-col>
  </v-row>
  <div class="text-error">{{errorMessage}}</div>
  <v-btn :loading="loading" @click="saveSeminar" v-if="isNew" :disabled="!seminar.title" variant="flat" color="primary" rounded class="mt-3">{{ $t('gamification.create_seminar') }}</v-btn>
</template>

<style scoped>

</style>